const GalleryData = [
    {
        platform: 'Twitter',
        handle: '@jrpgdog',
        image: '@jrpgdog'
    },
    {
        platform: 'Twitter',
        handle: '@appelsider_',
        image: '@applesider_'
    },
    {
        platform: 'Twitter',
        handle: '@chevoisknight',
        image: '@chevoisknight'
    },
    {
        platform: 'Twitter',
        handle: '@kimmycatsuragi',
        image: '@kimmycatsuragi'
    },
    {
        platform: 'Twitter',
        handle: '@eLTehH',
        image: '@eLTehH'
    },
    {
        platform: 'Twitter',
        handle: '@davioedv & @eLTehH',
        image: '@davioedv_@eLTehH'
    },
    {
        platform: 'Twitter',
        handle: '@7fuyuria',
        image: '@7fuyuria'
    },
    {
        platform: 'Twitter',
        handle: '@gojuu_m',
        image: '@gojuu_m'
    },
    {
        platform: 'Twitter',
        handle: '@hishimotsuki',
        image: '@hishimotsuki'
    },
    {
        platform: 'Twitter',
        handle: '@21stCenturyB0y',
        image: '@21stcenturyb0y'
    },
    {
        platform: 'Twitter',
        handle: '@Raichana',
        image: '@Raichana'
    },
    {
        platform: 'Twitter',
        handle: '@maskyarts',
        image: '@maskyarts'
    },
    {
        platform: 'Twitter',
        handle: '@insomniaesics',
        image: '@insomniaesics'
    },
    {
        platform: 'Twitter',
        handle: '@nerdtokwa1996',
        image: '@nerdtokwa1996'
    },
    {
        platform: 'Twitter',
        handle: '@RyuzumiSama',
        image: '@ryuzumisama'
    },
    {
        platform: 'Twitter',
        handle: '@GenmaTheArtist',
        image: '@GenmaTheArtist'
    },
    {
        platform: 'Twitter',
        handle: '@YuzuKiyochii',
        image: '@YuzuKiyochii'
    },
    {
        platform: 'Twitter',
        handle: '@Chad_Bridges',
        image: '@Chad_Bridges'
    },
    {
        platform: 'Tumblr',
        handle: 'fury-brand',
        image: 'fury-brand'
    },
    {
        platform: 'Instagram',
        handle: '@giselledoodles',
        image: '@giselledoodles'
    },
    {
        platform: 'Twitter',
        handle: '@HarulinaF',
        image: '@HarulinaF'
    },
    {
        platform: 'Twitter',
        handle: '@HarulinaF',
        image: '@HarulinaF-2'
    },
    {
        platform: 'Twitter',
        handle: '@hollow_studio',
        image: '@hollow_studio'
    },
    {
        platform: 'Twitter',
        handle: '@Jerry_sama98',
        image: '@Jerry_sama98'
    },
    {
        platform: 'Twitter',
        handle: '@mad_scientist92',
        image: '@mad_scientist92'
    },
    {
        platform: 'Twitter',
        handle: '@KaitoRizu',
        image: '@KaitoRizu'
    },
    {
        platform: 'Twitter',
        handle: '@WordsOnALine',
        image: '@WordsOnALine'
    },
    {
        platform: 'Twitter',
        handle: '@moshimoshibe',
        image: '@moshimoshibe'
    },
    {
        platform: 'Twitter',
        handle: '@Pulcella1',
        image: '@Pulcella1'
    },
    {
        platform: 'Twitter',
        handle: '@TastyThanatoast',
        image: '@TastyThanatoast'
    },
    {
        platform: 'Twitter',
        handle: '@Tisiphone_Star',
        image: '@tisiphone_star'
    },
    {
        platform: 'Instagram',
        handle: '@lasercatdesign',
        image: '@lasercatdesign'
    },
    {
        platform: 'Twitter',
        handle: '@twirlayaka',
        image: '@twirlayaka'
    },
    {
        platform: 'Twitter',
        handle: '@twirlayaka',
        image: '@twirlayaka-2'
    },
    {
        platform: 'Twitter',
        handle: '@SecondFormGale',
        image: '@SecondFormGale'
    },
    {
        platform: 'Twitter',
        handle: '@fukurofuro',
        image: '@fukurofuro'
    }
]

export default GalleryData;